import Naluri from '~/common/api/naluri'
import {
  PROGRESS_GET_USER_ASSESSMENTS_RESULT_FAILURE,
  PROGRESS_GET_USER_ASSESSMENTS_RESULT_LOADING,
  PROGRESS_GET_USER_ASSESSMENTS_RESULT_SUCCESS
} from './constants';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function getUserAssessmentsResults(userId) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PROGRESS_GET_USER_ASSESSMENTS_RESULT_LOADING,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const doRequest = Naluri.get(`/api/expert/assessments/${userId}`)
      doRequest.then(
        (response) => {
          const { productivity_scores, resilience_scores, empathy_scores } = response
          dispatch({
            type: PROGRESS_GET_USER_ASSESSMENTS_RESULT_SUCCESS,
            resilience_scores,
            productivity_scores,
            empathy_scores
          });
          resolve(response);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (error) => {
          dispatch({
            type: PROGRESS_GET_USER_ASSESSMENTS_RESULT_FAILURE,
            error,
          });
          reject(error);
        },
      );
    });

    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROGRESS_GET_USER_ASSESSMENTS_RESULT_LOADING:
      // Loading state
      return {
        ...state,
        loading: true,
        error: null
      };

    case PROGRESS_GET_USER_ASSESSMENTS_RESULT_SUCCESS:
      // The request is success
      return {
        ...state,
        loading: false,
        productivity_scores: action.productivity_scores,
        resilience_scores: action.resilience_scores,
        empathy_scores: action.empathy_scores,
        error: null
      };

    case PROGRESS_GET_USER_ASSESSMENTS_RESULT_FAILURE:
      // The request is failed
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/progress/redux/getUserAssessmentsResults.js